/**
 * User-related constants shared across frontend and backend.
 */

type SplitRegularMemberName = {
  firstName: string;
  lastName: string;
};

// Placeholder email domain for API users (who don't have real emails)
export const API_USER_EMAIL_DOMAIN = 'noemail.fake';

/**
 * Detects if an email belongs to an API user by checking the domain.
 */
export function isApiUserEmail(email: string): boolean {
  return email.endsWith(`@${API_USER_EMAIL_DOMAIN}`);
}

export function formatName(name: string): string {
  return name.split(',').join(' ');
}

export function splitRegularMemberName(name: string): SplitRegularMemberName {
  const trimmedName = name.trim();

  if (trimmedName.length === 0) {
    return { firstName: '', lastName: '' };
  }

  // Case: regular member names are currently stored as "first,last".
  if (trimmedName.includes(',')) {
    const [firstName = '', ...lastNameParts] = trimmedName.split(',');

    return {
      firstName: firstName.trim(),
      lastName: lastNameParts.join(',').trim(),
    };
  }

  // Case: tolerate legacy space-delimited names when parsing existing values.
  const parts = trimmedName.split(/\s+/).filter(Boolean);
  return {
    firstName: parts[0] ?? '',
    lastName: parts.slice(1).join(' '),
  };
}

export function serializeRegularMemberName(
  firstName: string,
  lastName: string
): string {
  return `${firstName.trim()},${lastName.trim()}`;
}
